import { defineStore } from "pinia";
import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

export const useCategoryMenuStore = defineStore("categoryMenu", {
  state: () => ({
    categoryMenuMega: [],
    categoryMenuMegaMobile: [],
  }),

  getters: {
    getCategoryMenuMega(state) {
      return state.categoryMenuMega;
    },
    getCategoryMenuMegaMobile(state) {
      return state.categoryMenuMegaMobile;
    },
  },
  actions: {
    async loadNewMenuMega() {
      try {
        const response = await getApiAxios(api.megaMenu.get_mega_menu+'?storeCode=vi');
        const results = response?.result;
        this.categoryMenuMega = results;
      } catch (error) {
        console.error(error);
      }
    },
    async loadNewMenuMegaMobile() {
      try {
        const response = await getApiAxios(api.megaMenu.get_mega_menu+'?storeCode=mobile');
        const results = response?.result;
        this.categoryMenuMegaMobile = results;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
